import { render, staticRenderFns } from "./RemoveSubjectForm.vue?vue&type=template&id=4753d872&"
import script from "./RemoveSubjectForm.vue?vue&type=script&lang=js&"
export * from "./RemoveSubjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports